<template>
  <div id="not-found" style="width:100%; margin: 0 auto; margin-top:100px; text-align: center;">
    <h3>Not Found</h3>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Page not found",
  },
  name: "NotFound",
};
</script>



// WEBPACK FOOTER //
// src/pages/event/NotFound.vue